import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

@Component({
  selector: 'mojo-ms-oauth-settings-viewer',
  templateUrl: './mojo-ms-oauth-settings-viewer.component.html',
  changeDetection: ChangeDetectionStrategy.Default
})
export class MojoMsOAuthSettingsViewerComponent {
  @Input() form : UntypedFormGroup;
}
